<template>

	<v-dialog v-model="this.$root.modalDialog.showDialog" persistent scrollable content-class="modalDialog" :fullscreen="mxnIsMobileDevice" width="60%">
		<v-card>
			<v-btn icon @click="closeDialog" class="closeBtn">
				<span class="material-icons iconSize24">highlight_off</span>
			</v-btn>
			<v-card-title class="py-0 title">
				<span>{{ $t(this.$root.modalDialog.title) }}</span>
				<div class="titleTriangle" />
			</v-card-title>
			<v-card-text class="content">
				<span v-html="this.$root.modalDialog.content" />
			</v-card-text>
			<v-card-actions class="actionArea">
				<button @click="closeDialog" class="btnPrimary">OK</button>
			</v-card-actions>
		</v-card>
	</v-dialog>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'

export default {
	name: 'ModalDialog',

	data: () => ({
		//
	}),

	beforeCreate() {
		Logger.log("ModalDialog.vue beforeCreate");
	},
	created() {
		Logger.log("ModalDialog.vue created");
	},
	beforeMount() {
		Logger.log("ModalDialog.vue beforeMount");
	},
	mounted() {
		Logger.log("ModalDialog.vue mounted");
	},
	beforeUpdate() {
		Logger.log("ModalDialog.vue beforeUpdate");
	},
	updated() {
		Logger.log("ModalDialog.vue updated");
	},
	beforeDestroy() {
		Logger.log("ModalDialog.vue beforeDestroy");
	},
	destroyed() {
		Logger.log("ModalDialog.vue destroyed");
	},
	methods: {
		closeDialog() {
			this.$root.modalDialog.showDialog = false;
			//this.$root.modalDialog.title = null;
			//this.$root.modalDialog.content = null;
		}
	}
}
</script>

<style lang="scss">

	@import '@/assets/scss/_definitions.scss';
	
	.modalDialog {

		.closeBtn {
			position: absolute;
			right: 0;
			//transform: translate(-0.6rem, 0.3rem);
			@include skinColor(color, --skinColPrimCompl, $skinColPrimCompl, 1.0, true);
		}

		.closeBtn::before {
			display: none;
		}

		.title {
			font-size: 1.25rem;
			font-weight: 600;
			margin-bottom: $dlgPadding;
			padding: 0 $dlgPadding;
			height: 3rem;
			line-height: 3rem;
			@include skinColor(background-color, --skinColPrim, $skinColPrim);
			@include skinColor(color, --skinColPrimCompl, $skinColPrimCompl);
		}

		.titleTriangle {
			@include skinColor(background-color, --skinColPrim, $skinColPrim);
			height: 1rem;
			left: 1.4rem;
			position: absolute;
			top: 2.5rem;
			transform: rotate(45deg);
			width: 1rem;
		}

		.content {
			height: 25rem;
			max-height: calc(100vh - 14rem);
			padding: $dlgPadding;

			::v-deep a {
				font-weight: 600;
				text-decoration: underline;
				white-space: nowrap;
			}
		}

		.actionArea {
			padding: $dlgPadding;
		}

		.btnPrimary {
			@include skinColor(background-color, --skinColSec, $skinColSec, 1.0, true);
			@include skinColor(color, --skinColSecCompl, $skinColSecCompl, 1.0, true);
			text-decoration: none;
			text-align: center;
			display: block;
			width: 100%;
			font-weight: 600;
			padding: 0.563rem 1.125rem 0.813rem;
		}

		.btnPrimary:hover {
			box-shadow: 0 0.375rem 0.75rem 0 $globColTert;
		}
	}

</style>
